import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { cloneDeep } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import {
  Answer,
  CreatePollParserCommand,
  GetEnumValuesDto,
  GetPollParserByIdDto,
  PhonebookDto,
  PollParserType,
  UserPrivateNumbersForSendDto,
} from 'src/app/core/api/models';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { PeriodicDateTimeConfig } from 'src/app/shared/components/periodic-date-time-picker/periodic-date-time-picker.component';
import { EnumsService } from '../../../../core/api/services/enums.service';
import { EventTypes } from '../../../../core/constants/event-types';
import { DialogService } from '../../../../core/services/dialog.service';

@Component({
  selector: 'app-base-parser-form',
  template: ``,
  standalone: false,
})
export abstract class BaseParserFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties
  dialogService = inject(DialogService);
  translate = inject(TranslateService);
  enumService = inject(EnumsService);

  periodicDateTimeConfig: PeriodicDateTimeConfig;
  model: CreatePollParserCommand = {};
  currentAnswer: Answer = {};
  formPageConfig: FormPageConfig<GetPollParserByIdDto> = {};

  // formulasForm: FormGroup;
  // responsesForm: FormGroup;

  // optionTitle: string = '';
  // answerValue: string = '';
  // selectedPhonebookId: number;
  // selectedPhonebookName: string;
  // isCorrect: boolean = false;

  get PollParserType() {
    return PollParserType;
  }

  PollParserResponseTypeEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  ngOnInit() {
    try {
      this.model.answers = [];
      super.ngOnInit();
      this.setComponentsConfig();
      this.setPageTitle();
      if (this.model.answers.length > 0)
        this.currentAnswer = this.model.answers[0];
      this.getEnumValuesApi('PollParserResponseType').subscribe(
        (values) => (this.PollParserResponseTypeEnumValues = values)
      );
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  initModel() {
    try {
      if (this.formPageConfig.isEditMode) {
        //copies nested editData model to this.model
        this.model = cloneDeep(this.formPageConfig.editData);
        this.model.privateNumberId =
          this.formPageConfig.editData.receiverPrivateNumber.id;
        this.model.privateNumberNumber =
          this.formPageConfig.editData.receiverPrivateNumber.number;
      } else {
        this.model = {};
        this.model.answers = [];
        this.model.notValidAnswersResponse = {};
        this.model.notValidAnswersResponse.privateNumber = {};
        this.onAddOption({ id: uuidv4() });
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  //#region init

  setPageTitle() {
    try {
      if (this.formPageConfig.isEditMode)
        this.title = this.pageVocabs + 'pollEditTitle';
      else this.title = this.pageVocabs + 'pollAddTitle';
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  initForm(): void {
    this.form = new FormGroup({
      title: new FormControl('', Validators.required),
      privateNumberId: new FormControl('', Validators.required),
      senderPhonebookId: new FormControl(''),
      isActive: new FormControl(''),
      startDate: new FormControl('', Validators.required),
      endDate: new FormControl('', Validators.required),
      startTime: new FormControl('', Validators.required),
      endTime: new FormControl('', Validators.required),
      optionTitle: new FormControl(''),
      answerValue: new FormControl(''),
      phonebookId: new FormControl(''),
      isCorrect: new FormControl(''),

      answerPrivateNumber: new FormControl('', Validators.required),
      answerText: new FormControl('', Validators.required),

      duplicatedPrivateNumber: new FormControl(''),
      duplicatedText: new FormControl(''),

      notValidAnswersResponsePrivateNumber: new FormControl(''),
      notValidAnswersResponseText: new FormControl(''),
    });

    // this.formulasForm = new FormGroup({
    //   optionTitle: new FormControl(''),
    //   answerValue: new FormControl(''),
    //   phonebookId: new FormControl(''),
    //   isCorrect: new FormControl(''),
    // });

    // this.responsesForm = new FormGroup({});
    // this.model.answers.forEach((item, index) => {
    // this.form.addControl(
    //   `privateNumber`,
    //   new FormControl('', Validators.required)
    // );
    // this.form.addControl(`text`, new FormControl('', Validators.required));
    // });
  }

  setComponentsConfig() {
    try {
      this.periodicDateTimeConfig = {
        startDateLabel: 'common.startDay',
        startTimeLabel: 'common.startHour',
        endDateLabel: 'common.endDay',
        endTimeLabel: 'common.endHour',
        startDateFormControl: this.form?.get('startDate') as FormControl,
        startTimeFormControl: this.form?.get('startTime') as FormControl,
        endDateFormControl: this.form?.get('endDate') as FormControl,
        endTimeFormControl: this.form?.get('endTime') as FormControl,
        responsiveClassName: 'sm:tw-w-1/2 xl:tw-w-1/3 xl:tw-w-1/4',
        endDateTimeValue: DateTimeService.getAYearLaterToIsoString(),
        isEditMode: this.formPageConfig.isEditMode,
        minStartDateType: 'today',
      };

      if (this.formPageConfig.isEditMode) {
        this.periodicDateTimeConfig.startDateTimeValue =
          this.formPageConfig.editData.startDateTime;
        this.periodicDateTimeConfig.endDateTimeValue =
          this.formPageConfig.editData.endDateTime;
      } else {
        this.periodicDateTimeConfig.startDateTimeValue =
          DateTimeService.getCurrentDateTime();
        this.periodicDateTimeConfig.endDateTimeValue =
          DateTimeService.getAYearLaterToIsoString();
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  //#endregion

  onSelectPrivateNumber(event: UserPrivateNumbersForSendDto) {
    try {
      if (!event) {
        this.model.privateNumberId = null;
        this.model.privateNumberId = null;
        return;
      }

      this.model.privateNumberNumber = event.number;
      this.model.privateNumberId = event.id;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  onAddOption(event?) {
    try {
      this.model.answers.push({
        id: event?.id,
        parentId: event?.parentId,
        title: '',
        answerValue: '',
        phonebookId: null,
        phonebookName: '',
        isCorrect: false,
        answerResponse: { privateNumber: {}, text: '' },
        // duplicationResponse: { privateNumber: {}, text: '' },
        isMainAnswer: !event?.parentId ? true : false,
      });
      this.getCurrentAnswer(event?.id);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  // isValidNewOption(): boolean {
  //   try {
  //     let result: boolean = true;

  //     // check option title
  //     if (!this.optionTitle) {
  //       result = false;
  //       this.dialogService.openDialog({
  //         title: this.translate.instant('common.error'),
  //         message: this.translate.instant(
  //           this.pageVocabs + 'messages.optionTitleRequired'
  //         ),
  //         status: DialogStatus.error,
  //       });
  //       return result;
  //     }

  //     // check keyword
  //     if (!this.answerValue) {
  //       result = false;
  //       this.dialogService.openDialog({
  //         title: this.translate.instant('common.error'),
  //         message: this.translate.instant(
  //           this.pageVocabs + 'messages.keywordRequired'
  //         ),
  //         status: DialogStatus.error,
  //       });
  //       return result;
  //     }

  //     // check option title is unique
  //     let optionSearched = this.model.answers.find((option) => {
  //       return option.title === this.optionTitle;
  //     });
  //     if (optionSearched) {
  //       result = false;
  //       this.dialogService.openDialog({
  //         title: this.translate.instant('common.error'),
  //         message: this.translate.instant(
  //           this.pageVocabs + 'messages.uniqueTitle'
  //         ),
  //         status: DialogStatus.error,
  //       });
  //       return result;
  //     }

  //     // check keyword title is unique
  //     optionSearched = this.model.answers.find((option) => {
  //       return option.answerValue === this.answerValue;
  //     });
  //     if (optionSearched) {
  //       result = false;
  //       this.dialogService.openDialog({
  //         title: this.translate.instant('common.error'),
  //         message: this.translate.instant(
  //           this.pageVocabs + 'messages.uniqueKeyword'
  //         ),
  //         status: DialogStatus.error,
  //       });
  //       return result;
  //     }

  //     return result;
  //   } catch (error) {
  //     this.loggerService.logError(this.tagName, error, EventTypes.services);
  //   }
  // }

  onChangeSelectPhonebook(event: PhonebookDto) {
    this.currentAnswer.phonebookId = event?.id;
    this.currentAnswer.phonebookName = event?.name;
  }

  onRemoveOption(id) {
    try {
      this.model.answers = this.deleteChildren(id);
      // this.model.formulas.splice(index, 1);
      this.model.answers = this.model.answers.filter((item) => item.id != id);
      this.currentAnswer = this.model.answers[0];
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  deleteChildren(previousFormulaId: string): Array<Answer> {
    // Find all children of the given previousFormulaId
    const children = this.model.answers.filter(
      (item) => item.parentId === previousFormulaId
    );

    // Recursively delete children of each child
    children.forEach((child) => {
      this.model.answers = this.deleteChildren(child.id);
    });

    // Remove the children from the main list
    return this.model.answers.filter(
      (item) => item.parentId !== previousFormulaId
    );
  }

  onSetResponsePrivateNumber(event: UserPrivateNumbersForSendDto) {
    try {
      this.currentAnswer.answerResponse.privateNumber.id = event.id;
      this.currentAnswer.answerResponse.privateNumber.number = event.number;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  onSetResponseText(event: string) {
    try {
      this.currentAnswer.answerResponse.text = event;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  onSetDuplicatedResponsePrivateNumber(event: UserPrivateNumbersForSendDto) {
    try {
      if (!this.currentAnswer.duplicationResponse) {
        this.currentAnswer.duplicationResponse = {};
        this.currentAnswer.duplicationResponse.privateNumber = {};
      }
      this.currentAnswer.duplicationResponse.privateNumber.id = event.id;
      this.currentAnswer.duplicationResponse.privateNumber.number =
        event.number;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  onSetDuplicatedResponseText(event: string) {
    try {
      if (!this.currentAnswer.duplicationResponse) {
        this.currentAnswer.duplicationResponse = {};
        this.currentAnswer.duplicationResponse.privateNumber = {};
      }
      if (event) this.currentAnswer.duplicationResponse.text = event;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  onSetNotValidAnswersResponsePrivateNumber(
    event: UserPrivateNumbersForSendDto
  ) {
    try {
      if (!this.model.notValidAnswersResponse) {
        this.model.notValidAnswersResponse = {};
        this.model.notValidAnswersResponse.privateNumber = {};
      }
      this.model.notValidAnswersResponse.privateNumber.id = event.id;
      this.model.notValidAnswersResponse.privateNumber.number = event.number;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  onSetNotValidAnswersResponseText(event: string) {
    try {
      if (!this.model.notValidAnswersResponse) {
        this.model.notValidAnswersResponse = {};
        this.model.notValidAnswersResponse.privateNumber = {};
      }
      if (event) this.model.notValidAnswersResponse.text = event;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  getCurrentAnswer(id: any) {
    this.currentAnswer = this.model.answers.find((item) => item.id === id);
  }

  onSubmit() {
    try {
      // this.responsesForm.markAllAsTouched();

      // if (
      //   !this.isValidForm(
      //     this.responsesForm,
      //     this.tagName + ' ' + 'app-sms-body'
      //   )
      // )
      //   return;

      super.onSubmit();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  onRefresh() {
    this.initModel();
    this.setComponentsConfig();
  }
}
